import React from 'react';

import { RemindersTableWithAddOption } from '../../components/RemindersTableWithAddOption';
import { useGetCandidateReminders } from '../reminders/useGetCandidateReminders';

export const CandidateRemindersTable: React.FC<{ candidateId: string }> = ({ candidateId }) => {
  const { data } = useGetCandidateReminders(candidateId);

  return <RemindersTableWithAddOption objectId={candidateId} objectClass="CANDIDATE" data={data} />;
};
